export const routingLooksMasked = (value: string): boolean =>
  value.includes("*") || /^\d{4}$/.test(value);

/** Last-4 storage or X-prefix display mask — not a freshly typed / excel value. */
export const accountNumberLooksMasked = (value: string): boolean =>
  value.includes("X") || /^\d{1,4}$/.test(value);

export const isValidRoutingNumber = (value: string): boolean =>
  /^\d{9}$/.test(value);

const toRoutingString = (value: unknown): string => {
  if (typeof value === "string") return value;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return "";
};

/**
 * Routing value Save/Submit should 9-digit-check. Matches the edit input:
 * decrypted/typed first, else the stored value still shown on screen.
 * A masked last-4 / stars is published as "" so a previous-draw mask is not
 * treated as an invalid short routing. Excel-uploaded plaintext like "67565"
 * is not a mask, so it is published and the 9-digit rule can fire.
 */
export const visibleRoutingForValidation = (
  showingEdit: boolean,
  editDecryptedRouting: string | undefined,
  storedRouting: unknown
): string => {
  if (!showingEdit) return "";
  if (editDecryptedRouting != null) return String(editDecryptedRouting);
  const stored = toRoutingString(storedRouting);
  return routingLooksMasked(stored) ? "" : stored;
};
